import toast from "react-hot-toast";

export const showSuccess = (message: string) => {
  toast.success(message, {
    duration: 3000,
    position: "top-right",
    style: {
      background: "#10b981",
      color: "#fff",
      padding: "16px",
      borderRadius: "8px",
    },
  });
};

export const showError = (message: string) => {
  toast.error(message, {
    duration: 4000,
    position: "top-right",
    style: {
      background: "#ef4444",
      color: "#fff",
      padding: "16px",
      borderRadius: "8px",
    },
  });
};

export const showInfo = (message: string) => {
  toast(message, {
    duration: 3000,
    position: "top-right",
    icon: "ℹ️",
    style: {
      background: "#3b82f6",
      color: "#fff",
      padding: "16px",
      borderRadius: "8px",
    },
  });
};

export const showWarning = (message: string) => {
  toast(message, {
    duration: 3500,
    position: "top-right",
    icon: "⚠️",
    style: {
      background: "#f59e0b",
      color: "#fff",
      padding: "16px",
      borderRadius: "8px",
    },
  });
};

// For confirmation dialogs, we still need to use native confirm
// but we can show a toast after the action
export const showConfirm = (message: string): boolean => {
  return window.confirm(message);
};
